import { render, staticRenderFns } from "./SettingList.vue?vue&type=template&id=57630068"
import script from "./SettingList.vue?vue&type=script&lang=js"
export * from "./SettingList.vue?vue&type=script&lang=js"
import style0 from "./SettingList.vue?vue&type=style&index=0&id=57630068&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports